















































































































































































































































































































































































































































































import "bootstrap-vue";
import Vue from "vue";
import Component from "vue-class-component";
import { Prop, Watch } from "vue-property-decorator";
import Multiselect from "vue-multiselect";
import DatePicker from "vue2-datepicker";
import store from "@/services/store";
import VueElementLoading from "vue-element-loading";
import axios from "axios";
import { log } from "@amcharts/amcharts4/.internal/core/utils/Log";

export interface IOrganization {
    id: string;
    nameRu: string;
    nameKz: string;
}

interface IOperation {
    id: number;
    code: string;
    nameRu: string;
    operation: string;
    op_name: string;
    module: string;
    checked: boolean;
}

export interface IAppTempGeneral {
    id: number;
    typeOrderId: number;
    createDate: number;
    userId: string;
}

export interface ITempElement {
    id: number;
    appTemplateAccessModulesId: number;
    modules: string;
    accessLevel: number;
    operations: string[];
    createDate: number;
}

export interface ITemplateDetail {
    appTemplateAccessModules: IAppTempGeneral;
    elements: ITempElement[];
}

export class TemplateDataClass {
    public id: number = 0;
    public name: string = "";
    public typeOrderId: number = 0;
    // public organization: string = "";
    public orgType: { orgTypeName: string; orgTypeId: number } = {
        orgTypeName: "",
        orgTypeId: 0,
    };
    public modules: string = "";
    public accessLevel: number = 1;
    public operations: { op_name: string; checked: boolean }[] = [];
    public isModuleDrown: boolean = true;

    constructor(init?: Partial<TemplateDataClass>) {
        if (init) {
            Object.assign(this, init);
        }
    }
}

export interface IModule {
    id: number;
    code: string;
    name_ru: string;
    accessLevel: number;
    operations: { op_name: string; checked: boolean }[];
    isModuleDrown: boolean;
}

@Component({
    name: "adminSample",
    components: {
        multiselect: Multiselect,
        loading: VueElementLoading,
    },
})
export default class AdminSample extends Vue {
    $refs!: {
        drop: HTMLFormElement;
        typeOrgList: HTMLFormElement;
    };
    // @Prop({ required: true }) activeTab!: number;
    private mode: "view" | "edit" | "create" = "view";
    @Prop({ required: true })
    private isUserSupport!: boolean;
    public templateData: TemplateDataClass = new TemplateDataClass();

    private isSaved: boolean = false;
    private isEdited: boolean = false;
    private showNewAppForm: boolean = false;
    private backAppList: boolean = true;
    private showAddModuleForm: boolean = false;
    private showAllTempCreated: boolean = false;
    private isAddConfirmed: boolean = false;
    private showDelModal: boolean = false;
    // private selectAllTemp: boolean = false;
    // private selectedTempItems: number[] = [];
    private selectedTemp: any = null;

    @Prop({ required: true }) getModules!: () => Promise<any[]>;
    @Prop({ required: true }) getTypesOrg!: () => Promise<any[]>;
    @Prop({ required: true }) getOperations!: (
        module: string
    ) => Promise<any[]>;

    private operationsList: IOperation[] = [];

    private templateList: any[] = [];
    private moduleList: any[] = [];
    private searchModule: string = "";
    private selectedModItems: string[] = [];
    private selectedModules: any[] = [];
    private templateModules: any[] = [];
    private selectAllModule: boolean = false;

    private selectGr: boolean = false;

    private typeOrgList: IOrganization[] = [];
    private unusedOrgTypeList: IOrganization[] = [];
    private selectedTypeOrg: any = null;

    private bar: number = 0;
    private loading: boolean = false;
    private checkboxId: string = "";

    get userId() {
        return store.getters.user_uuid;
    }

    get filteredModules(): any[] {
        if (!this.searchModule) {
            return this.moduleList;
        } else {
            const query = this.searchModule.toLowerCase();
            return this.moduleList.filter((item) => {
                return (
                    item.code.toString().toLowerCase().includes(query) ||
                    item.name_ru.toLowerCase().includes(query)
                );
            });
        }
    }

    public async created() {
        try {
            await this.loadTemplateList();
            await this.loadModules();
            this.checkboxId =
                "temp-check-all-" +
                Date.now().toString(36) +
                Math.random().toString(36).slice(2, 7);
        } catch (error) {
            if (error instanceof Error) {
                this.makeToast(
                    "danger",
                    "Ошибка в процессе инициализации:",
                    error.message
                );
            }
        }
    }

    public async mounted() {}

    private async createNewTemplate() {
        // this.resetCheckModules();
        this.selectedModItems = [];
        this.selectAllModule = false;
        this.searchModule = "";

        this.selectedModules = [];
        this.templateModules = [];
        this.moduleList = this.moduleList.map((module) => ({
            ...module,
            check: false,
        }));
        this.mode = "create";
        this.isSaved = false;

        await this.loadUnusedTypesOrg();
        if (this.unusedOrgTypeList.length === 0 && this.backAppList) {
            this.showAllTempCreated = true;
        } else {
            this.showAddModuleForm = true;
        }
    }

    private async backToAppList() {
        this.backAppList = true;
        this.showNewAppForm = false;
        await this.loadTemplateList();
    }

    private async loadTemplateList() {
        try {
            const response = await axios.get(`api/um/admin/mode/template-list`);
            const data = response.data;
            await this.loadTypesOrg();
            this.templateList = data.map((item: any) => {
                const formattedDate = this.formatDateFromBack(item.create_date);
                const formattedTime = this.formatTimeFromBack(item.create_date);
                const typeOrgName = this.typeOrgList.find(
                    (data) => data.id === item.typeorder
                );

                return {
                    ...item,
                    typeOrg: typeOrgName ? typeOrgName.nameRu : item.typeorder,
                    createDate: formattedDate,
                    createTime: formattedTime,
                };
            });
        } catch (error) {
            if (error instanceof Error) {
                this.makeToast(
                    "danger",
                    "Ошибка запроса списка шаблонов",
                    error.message
                );
            }
        }
    }

    private formatDateFromBack(timestamp: number): string {
        const date = new Date(timestamp);
        return new Intl.DateTimeFormat("ru-RU", {
            day: "numeric",
            month: "long",
            year: "numeric",
        }).format(date);
    }

    private formatTimeFromBack(timestamp: number): string {
        const date = new Date(timestamp);
        return new Intl.DateTimeFormat("ru-RU", {
            hour: "2-digit",
            minute: "2-digit",
        }).format(date);
    }

    private async loadUnusedTypesOrg() {
        try {
            this.unusedOrgTypeList = [];
            const response = await fetch(
                "/api/um/admin/mode/template-type-order"
            );
            const data = await response.json();
            this.unusedOrgTypeList = data;
            this.selectedTypeOrg = this.unusedOrgTypeList[0];
        } catch (error) {
            if (error instanceof Error) {
                this.makeToast(
                    "danger",
                    "Ошибка запроса видов предприятия",
                    error.toString()
                );
            }
        }
    }

    private async loadTypesOrg() {
        if (this.getTypesOrg) {
            this.typeOrgList = await this.getTypesOrg();
        }
    }

    private async loadModules() {
        if (this.getModules) {
            const response = await this.getModules();
            // API может вернуть модуль с одним кодом несколько раз — оставляем первый (code используется как :key)
            const uniqueModules = response.filter(
                (module, index, arr) =>
                    arr.findIndex((m) => m.code === module.code) === index
            );
            this.moduleList = uniqueModules.map((module) => {
                const accessLevel = 1;
                return {
                    ...module,
                    accessLevel,
                    isModuleDrown: true,
                    operations: [],
                };
            });
        }
    }

    private get visibleGroupsCount() {
        return (operations: IOperation[]) => {
            return (
                Object.values(this.groupOperations(operations)).filter(
                    (group) => group.items.length
                ).length || 1
            );
        };
    }

    private groupOperations(
        operations: IOperation[]
    ): Record<string, { title: string; items: IOperation[] }> {
        const groups: Record<string, { title: string; items: IOperation[] }> = {
            "01": { title: "Согласование", items: [] },
            "02": { title: "Подписание", items: [] },
            "03": { title: "Отчеты", items: [] },
            "04": { title: "Другое", items: [] },
        };

        operations.forEach((op) => {
            if (!op.checked) Vue.set(op, "checked", false); // поле для чекбокса
            if (groups[op.code]) {
                groups[op.code].items.push(op);
            } else {
                groups["04"].items.push(op);
            }
        });

        return groups;
    }

    private async handleAddTemplate(): Promise<void> {
        this.isAddConfirmed = true;

        if (this.mode === "create") {
            await this.openNewTemplateForm();
        } else {
            await this.openExistTemplateForm();
        }
        this.showAddModuleForm = false;
        this.backAppList = false;
        this.showNewAppForm = true;
    }

    private async openNewTemplateForm() {
        this.mode = "create";
        await this.loadOperationCheckModules();
    }

    private async openExistTemplateForm() {
        try {
            this.loading = true;

            // Кэшир текущие чеки
            const cachedOperations: Record<
                string,
                { operation: string; checked: boolean }[]
            > = {};
            this.templateModules.forEach((module) => {
                cachedOperations[module.code] = module.operations.map(
                    (op: any) => ({
                        operation: op.operation,
                        checked: op.checked,
                    })
                );
            });

            // Список всех выбранных модулей
            const selectedModuleCodes = this.moduleList
                .filter((module: any) => module.check)
                .map((module: any) => module.code);

            //Загрузка операции для всех выбранных модулей
            const modulesWithOps: IModule[] = await Promise.all(
                this.moduleList
                    .filter((module: any) =>
                        selectedModuleCodes.includes(module.code)
                    )
                    .map(async (module: any): Promise<IModule> => {
                        const apiOps = await this.getOperations(module.code);
                        const cachedOps = cachedOperations[module.code] || [];

                        // Мердж apiOps с cachedOps
                        const mergedOps = apiOps.map((op: any) => {
                            const cached = cachedOps.find(
                                (c) => c.operation === op.operation
                            );
                            return {
                                operation: op.operation,
                                op_name: op.op_name,
                                code: op.code,
                                checked: cached ? cached.checked : false,
                            };
                        });

                        const existingModule = this.templateModules.find(
                            (m) => m.code === module.code
                        );

                        return {
                            ...module,
                            accessLevel: existingModule
                                ? existingModule.accessLevel
                                : 1,
                            operations: mergedOps,
                        };
                    })
            );

            // Обновл templateModules
            this.templateModules = modulesWithOps.sort((a, b) =>
                a.code.localeCompare(b.code)
            );
            this.selectedModules = [...this.templateModules];
        } catch (error) {
            if (error instanceof Error) {
                this.makeToast(
                    "danger",
                    "Ошибка при загрузке шаблона",
                    error.message
                );
            }
        } finally {
            this.loading = false;
        }
    }

    private async loadOperationCheckModules() {
        try {
            this.loading = true;
            this.selectedModules = await Promise.all(
                this.moduleList
                    .filter((module) => module.check)
                    .map(async (module) => {
                        const operationsList = await this.getOperations(
                            module.code
                        );

                        return {
                            ...module,
                            accessLevel: Number(module.accessLevel),
                            operations: operationsList.map((op: any) => ({
                                operation: op.operation,
                                op_name: op.op_name,
                                code: op.code,
                                checked: false,
                            })),
                        };
                    })
            );
            this.selectedModules.sort((a, b) => a.code.localeCompare(b.code));
        } catch (error) {
            if (error instanceof Error) {
                this.makeToast(
                    "danger",
                    "Ошибка при загрузке операции для выбранных модулей",
                    error.message
                );
            }
        } finally {
            this.loading = false;
        }
    }

    private async loadOperationCheckModulesForEdit() {
        try {
            this.loading = true;

            const newModules: IModule[] = await Promise.all(
                this.moduleList
                    .filter((module: any) => module.check)
                    .map(async (module: any): Promise<IModule> => {
                        const apiOps = await this.getOperations(module.code);
                        const savedModule = this.templateModules.find(
                            (m: IModule) => m.code === module.code
                        );

                        const mergedOps = apiOps.map((op: any) => {
                            const savedOp = savedModule?.operations.find(
                                (o: any) => o.op_code === op.operation
                            );
                            return {
                                operation: op.operation,
                                op_name: op.op_name,
                                code: op.code,
                                checked: savedOp ? savedOp.checked : false,
                            };
                        });
                        return {
                            ...module,
                            accessLevel: savedModule
                                ? savedModule.accessLevel
                                : 1,
                            operations: mergedOps,
                        };
                    })
            );

            newModules.forEach((newModule) => {
                const idx = this.templateModules.findIndex(
                    (m: IModule) => m.code === newModule.code
                );
                if (idx === -1) {
                    this.templateModules.push(newModule);
                } else {
                    this.templateModules[idx] = {
                        ...this.templateModules[idx],
                        operations: newModule.operations,
                    };
                }
            });

            const activeCodes = this.moduleList
                .filter((m: any) => m.check)
                .map((m: any) => m.code);
            this.templateModules = this.templateModules.filter((m: IModule) =>
                activeCodes.includes(m.code)
            );

            this.templateModules.sort((a, b) => a.code.localeCompare(b.code));
            this.selectedModules = [...this.templateModules];
        } catch (error) {
            if (error instanceof Error) {
                this.makeToast(
                    "danger",
                    "Ошибка при загрузке операций для выбранных модулей",
                    error.message
                );
            }
        } finally {
            this.loading = false;
        }
    }

    private resetCheckModules(): void {
        if (!this.isAddConfirmed) {
            this.selectedModItems = [];
            this.selectAllModule = false;
            this.searchModule = "";
            this.showAddModuleForm = false;
            // this.backToAppList();
        }

        this.isAddConfirmed = false;
    }

    private toggleModuleDrown(moduleCode: string): void {
        const targetModule =
            this.mode === "create"
                ? this.selectedModules.find(
                      (m: IModule) => m.code === moduleCode
                  )
                : this.templateModules.find(
                      (m: IModule) => m.code === moduleCode
                  );
        if (targetModule) {
            targetModule.isModuleDrown = !targetModule.isModuleDrown;
        }
    }

    private removeModule(moduleCode: string) {
        this.selectedModules = this.selectedModules.filter(
            (module) => module.code !== moduleCode
        );

        this.templateModules = this.templateModules.filter(
            (module) => module.code !== moduleCode
        );

        this.moduleList.forEach((module: any) => {
            module.check = this.selectedModules.some(
                (m: IModule) => m.code === module.code
            );
        });
    }

    groupSelectState(operations: any, groupKey: any) {
        const group = this.groupOperations(operations)[groupKey];
        return group.items.every((op) => op.checked);
    }

    toggleGroupSelection(operations: any, groupKey: any) {
        const group = this.groupOperations(operations)[groupKey];
        const newState = !this.groupSelectState(operations, groupKey);
        group.items.forEach((op) => (op.checked = newState));
    }

    private toggleSelectAll() {
        if (this.selectAllModule) {
            this.selectedModItems = this.filteredModules.map(
                (item) => item.code
            );
        } else {
            this.selectedModItems = [];
        }
        this.moduleList.forEach((module) => {
            module.check = this.selectedModItems.includes(module.code);
        });
    }

    private updateSelectAll() {
        this.moduleList.forEach((module) => {
            module.check = this.selectedModItems.includes(module.code);
        });

        this.selectAllModule =
            this.filteredModules.length > 0 &&
            this.filteredModules.every((module) =>
                this.selectedModItems.includes(module.code)
            );
    }

    // private toggleSelectTemp() {
    //     if (this.selectAllTemp) {
    //         this.selectedTempItems = this.templateList.map((item) => item.id);
    //     } else {
    //         this.selectedTempItems = [];
    //     }
    //     this.templateList.forEach((temp) => (temp.check = this.selectAllTemp));
    // }

    // private updateSelectTempAll() {
    //     if (this.selectedTempItems.length === this.templateList.length) {
    //         this.selectAllTemp = true;
    //     } else {
    //         this.selectAllTemp = false;
    //     }
    // }

    private async operCheckboxChange(oper: any) {
        oper.check = !oper.check;
    }

    private async openTemplateForm(item: any) {
        this.mode = "view";
        this.selectedTemp = item;
        const id = item.id;
        await this.getDetailTemplate(id);
        this.isEdited = false;
        this.showNewAppForm = true;
        this.showAddModuleForm = false;
        this.backAppList = false;
    }

    private async getDetailTemplate(idTemplate: number): Promise<void> {
        try {
            this.loading = true;
            this.templateModules = [];
            this.selectedModules = [];
            const response = await axios.get(
                `/api/um/admin/mode/template-elements?idtemplate=${idTemplate}`
            );
            const templateDetails: ITemplateDetail = response.data;
            const orgTypeName =
                this.typeOrgList.find(
                    (org: any) =>
                        org.id ===
                        templateDetails.appTemplateAccessModules.typeOrderId
                )?.nameRu || "";

            this.templateData = new TemplateDataClass();
            this.templateData.id = templateDetails.appTemplateAccessModules.id;
            this.templateData.orgType = {
                orgTypeName: orgTypeName,
                orgTypeId: templateDetails.appTemplateAccessModules.typeOrderId,
            };

            this.templateModules = await Promise.all(
                templateDetails.elements.map(
                    async (element: ITempElement): Promise<IModule> => {
                        const moduleName =
                            this.moduleList.find(
                                (module: any) => module.code === element.modules
                            )?.name_ru || "";
                        const operationsList = await this.getOperations(
                            element.modules
                        );
                        return {
                            id: element.id,
                            code: element.modules,
                            name_ru: moduleName,
                            accessLevel: element.accessLevel,
                            operations: Array.isArray(element.operations)
                                ? element.operations.map((op: string) => {
                                      const opDetail = operationsList.find(
                                          (oper: any) => oper.operation === op
                                      );
                                      return {
                                          op_name: opDetail
                                              ? opDetail.op_name
                                              : op,
                                          op_code: op,
                                          code: opDetail ? opDetail.code : "",
                                          checked: true,
                                      };
                                  })
                                : [],
                            isModuleDrown: true,
                        };
                    }
                )
            );
            this.templateModules.sort((a, b) => a.code.localeCompare(b.code));
        } catch (error) {
            if (error instanceof Error) {
                this.makeToast(
                    "danger",
                    "Ошибка при загрузке детальных данных шаблона",
                    error.message
                );
            }
        } finally {
            this.loading = false;
        }
        // console.log("id tenplate", idTemplate)
    }

    private async editTemplate(): Promise<void> {
        this.mode = "edit";
        this.isSaved = false;
        this.isEdited = true;
        this.loading = true;

        const templateModuleCodes = this.templateModules.map((m) => m.code);
        this.moduleList.forEach((module: any) => {
            module.check = templateModuleCodes.includes(module.code);
        });

        await this.loadOperationCheckModulesForEdit();
        this.loading = false;
    }

    private async addNewModule(): Promise<void> {
        this.mode = "edit";
        this.isSaved = false;
        this.isEdited = true;
        this.searchModule = "";
        this.showAddModuleForm = true;
        this.selectedModItems = this.templateModules.map(
            (module: IModule) => module.code
        );

        this.moduleList.forEach((module: any) => {
            module.check = this.selectedModItems.includes(module.code);
        });
    }

    private async saveTemplate() {
        this.isSaved = true;
        try {
            let formData = {};

            if (this.mode === "create") {
                formData = {
                    appTemplateAccessModules: {
                        typeOrderId: this.selectedTypeOrg.id,
                    },
                    elements: this.selectedModules.map((module) => ({
                        modules: module.code,
                        accessLevel: Number(module.accessLevel),
                        operations: module.operations
                            ? module.operations
                                  .filter((op: IOperation) => op.checked)
                                  .map((op: IOperation) => op.operation)
                            : [],
                    })),
                };
            } else {
                formData = {
                    appTemplateAccessModules: {
                        ...(this.selectedTemp?.id && {
                            id: this.selectedTemp.id,
                        }),
                        typeOrderId: this.templateData.orgType.orgTypeId,
                    },
                    elements: this.selectedModules.map((module) => ({
                        modules: module.code,
                        accessLevel: Number(module.accessLevel),
                        operations: module.operations
                            ? module.operations
                                  .filter((op: IOperation) => op.checked)
                                  .map((op: IOperation) => op.operation)
                            : [],
                    })),
                };
            }

            const response = await axios.post(
                "/api/um/admin/mode/template-save",
                formData
            );
            if (response.status === 200) {
                this.makeToast(
                    "success",
                    "Запись успешно сохранена.",
                    "Сохранено"
                );
                this.templateModules = [...this.selectedModules];
                if (this.mode === "create") {
                    this.templateData.orgType = {
                        orgTypeId: this.selectedTypeOrg.id,
                        orgTypeName: this.selectedTypeOrg.nameRu,
                    };
                }
                this.mode = "view";
                this.isEdited = false;

                if (response.data && typeof response.data === "number") {
                    await this.getDetailTemplate(response.data);
                    this.selectedTemp = {
                        ...(this.selectedTemp || {}),
                        id: response.data,
                    };
                } else {
                    console.error(
                        "Ошибка при получении ID шаблона",
                        response.data
                    );
                }
            } else {
                throw new Error(`Ошибка сервера: ${response.status}`);
            }
        } catch (error) {
            if (error instanceof Error) {
                this.makeToast(
                    "danger",
                    "Ошибка при сохранении данных",
                    error.message
                );
            }
        }
    }

    private cancelDelete() {
        this.showDelModal = false;
        this.selectedTemp = null;
    }

    private confirmDeleteTemp(item: any) {
        this.selectedTemp = item;
        this.showDelModal = true;
    }

    private async deleteTemplate() {
        if (this.selectedTemp) {
            try {
                const idTemplate = this.selectedTemp.id;
                const response = await axios.delete(
                    `api/um/admin/mode/template-delete/${idTemplate}`
                );

                if (response.status === 200) {
                    this.makeToast(
                        "success",
                        "Шаблон успешно удален.",
                        "Сообщение"
                    );
                    await this.loadTemplateList();
                } else {
                    throw new Error(`Ошибка сервера: ${response.status}`);
                }
            } catch (error) {
                if (error instanceof Error) {
                    this.makeToast(
                        "danger",
                        "Ошибка при удалении проекта",
                        error.toString()
                    );
                }
            }
        }
        this.showDelModal = false;
    }

    makeToast(variant: string | undefined, tostbody: any, title: string) {
        this.$bvToast.toast(tostbody, {
            title: title,
            variant: variant,
            toaster: "b-toaster-top-center",
            autoHideDelay: 2000,
            solid: true,
            appendToast: true,
        });
    }
}
